export default "__VITE_ASSET__BbpgKo9w__"